import { createAction } from './createAction';

export const UPDATE_PRODUCT_DELIVERY = 'UPDATE_PRODUCT_DELIVERY';

export const updateProductDelivery = createAction(
  UPDATE_PRODUCT_DELIVERY,
  'startDate',
  'endDate',
);
